/**
 * Where the policy replacement pages live. The progress page's address is also what the requester's
 * notifications link to (#6256), so it stays `/policy-replacements/{id}`.
 */
export const POLICY_REPLACEMENTS_ROOT = "policy-replacements";

/** The query parameters the replace page reads. */
export const ReplacePolicySearch = {
  /** The client policy document to replace. */
  documentId: "documentId",
  /** The agreement the client started from, so the page can lead back to it. */
  workAgreementId: "workAgreementId",
} as const;

export function replacePolicyPath(documentId: string, workAgreementId?: string): string {
  const search = new URLSearchParams({ [ReplacePolicySearch.documentId]: documentId });
  if (workAgreementId) search.set(ReplacePolicySearch.workAgreementId, workAgreementId);
  return `/${POLICY_REPLACEMENTS_ROOT}/new?${search.toString()}`;
}

export function policyReplacementPath(policyReplacementId: string): string {
  return `/${POLICY_REPLACEMENTS_ROOT}/${policyReplacementId}`;
}

export function workAgreementPath(workAgreementId: string): string {
  return `/work/active/view/${workAgreementId}/details`;
}

/** A revision is a proposal; the revise route is the one the agreement page's own banner opens it on. */
export function revisionPath(proposalId: string): string {
  return `/proposals/active/revise/${proposalId}/details`;
}

export function proposalPath(proposalId: string): string {
  return `/proposals/active/view/${proposalId}/details`;
}
